import {gsap} from 'gsap';

import main from './PC/main';
import section2 from './PC/section2';
import remote from './PC/remote';

const _animation = function () {
    return gsap.timeline({paused: true})
        .addLabel('start')
        .from('.p-header__tit', {opacity: 0,y:7, duration: .9, ease: 'Power0.easeInOut'}, 'start+=.4')
        .from('.p-header__play', {opacity: 0, duration: .9, ease: 'Power0.easeInOut'}, 'start+=.4')
        .from('.p-header__btn', {opacity: 0,y:-7, duration: .9, ease: 'Power0.easeInOut'}, 'start+=.4')
        .from('.p-header__scroll', {opacity: 0,y:-7, duration: .9, ease: 'Power0.easeInOut'}, 'start+=.4')
        .staggerTo(".p-header__ch--back", 0.35, {x:"+=500", opacity:1}, 0.02, 'start+=1')
        .staggerTo(".p-header__ch--front", 0.35, {x:"+=500", opacity:1}, 0.02, 'start+=1.05')
        // .from('.p-header__ch--back', {opacity: 0, x:-500, duration: .2, ease: 'Power4.easeIn'}, 'start+=.4')
        // .from('.p-header__ch--front', {opacity: 0, x:-500, duration: .2, ease: 'Power4.easeIn'}, 'start+=.5')
};


promokit.page({
    components: [
        main,
        section2,
        remote
    ],

    game: 'bns',

    menu: true,

    cnb: true,

    footer: {
        fixed: true,
        theme: 'white' //'black', 'white'
    },

    headerButton: {
        el: '.header-button',
        cookie: {
            type: 'day',
            key: 'INDEX_WEB_VISIT_201007_update',
            value: false
        },
        update:true,
        home: true,
        sns: true,
        theme: 'black'
    }
});


promokit.preload({
    complete: () => {
        _animation().play();
        // console.log('complete preload');
    }
});


// WEBPACK FOOTER //
// ./src/js/index.js